import React, { Fragment } from 'react';
import styles from './styles.scss';
import Link from 'Components/Link';

export const InfoTextForMatelsoCookies = (props) => {
  return (
    <Fragment>
      <h5 lang="en" className={styles.marginBottomOneRow}>
        Matelso Call Tracking
      </h5>
      <h6 className={styles.h7_small_margin}>Beschreibung des Dienstes</h6>
      <p className={styles.marginBottomOneRow}>
        Das ist ein <span lang="en">Tracking</span>-Dienst zum Zwecke der Konversionmessung und
        -optimierung. Weitere Informationen hierzu finden Sie in unserer Datenschutzerklärung.
      </p>
      <h6 className={styles.h7_small_margin}>Verarbeitendes Unternehmen</h6>
      <p>
        matelso GmbH, Europaallee 34, 67657 Kaiserslautern, Deutschland; Website:{' '}
        <Link to="https://matelso.com/" label="https://matelso.com/" isExternal />; Informationen
        zum Datenschutz:{' '}
        <Link
          to="https://matelso.com/datenschutz/"
          label="https://matelso.com/datenschutz/"
          isExternal
          target="_blank"
        />
        .
      </p>
      <ul>
        <li>
          <u>
            <strong>Kategorie</strong>
          </u>
          <ul>
            <li>
              Analyse-/<span lang="en">Tracking</span>-Cookies
            </li>
          </ul>
        </li>
        <li>
          <u>
            <strong>Zweck der Daten</strong>
          </u>
          <p>Diese Liste stellt die Zwecke der Erhebung und Verarbeitung der Daten dar.</p>
          <ul>
            <li>Konversionsmessung/-optimierung</li>
            <li>Kampagnenoptimierung</li>
          </ul>
        </li>
        <li>
          <u>
            <strong>Erhobene Daten</strong>
          </u>
          <p>
            Diese Liste enthält alle (personenbezogenen) Daten, die durch oder bei der Verwendung
            dieses Dienstes erhoben werden.
          </p>
          <ul>
            <li>Rufnummer</li>
            <li>
              <span lang="en">Caller-ID</span>
            </li>
            <li>Datum und Uhrzeit des Anrufs</li>
            <li>Dauer des Anrufs</li>
            <li>IP-Adresse</li>
            <li>Cookie-IDs</li>
          </ul>
        </li>
      </ul>
      <h6 className={styles.h7}>Verwendete Technologien</h6>
      <p>
        Diese Liste stellt alle Technologien dar, die dieser Dienst zur Datenerhebung verwendet.
        Typische Technologien sind Cookies und Pixel, die im Browser platziert werden.
      </p>
      <ul>
        <li>Cookies</li>
        <li>Skript</li>
      </ul>
      <h6 className={styles.h7}>Rechtsgrundlagen</h6>
      <p>Im Folgenden sind die erforderlichen Rechtsgrundlagen der Datenverarbeitung aufgeführt.</p>
      <ul>
        <li>Art. 6 Abs. 1 s. 1 lit. a DSGVO</li>
      </ul>
      <h6 className={styles.h7}>Standort der Verarbeitung</h6>
      <p>
        Das ist der primäre Standort der Verarbeitung der erhobenen Daten. Wir informieren Sie,
        falls die Informationen in anderen Ländern verarbeitet werden.
      </p>
      <ul>
        <li>Europäische Union</li>
      </ul>
      <h6 className={styles.h7}>Dauer der Datenspeicherung</h6>
      <p>
        Die Aufbewahrungsfrist ist die Zeitspanne, in der die erhobenen Daten für die Zwecke der
        Verarbeitung gespeichert werden. Die Daten sind zu löschen, sobald sie für die angegebenen
        Verarbeitungszwecke nicht mehr benötigt werden.
      </p>
      <ul>
        <li>
          Die Daten sind zu löschen, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr
          benötigt werden.
        </li>
        <li>Maximale Dauer der Cookie-Speicherung: 2 Jahre</li>
      </ul>
      <h6 className={styles.h7}>Vertrieb in Drittländern</h6>
      <p>
        Der Dienst selbst überträgt die erhobenen Daten nicht in ein anderes Land. Bitte beachten
        Sie, dass dieser Dienst die Daten an Google Analytics überträgt.
      </p>
      <h6 className={styles.h7}>Datenempfänger</h6>
      <p>Im Folgenden sind die Empfänger der erhobenen Daten aufgeführt.</p>
      <ul>
        <li>matelso GmbH</li>
      </ul>
      <p className={styles.marginBottomOneRow}>
        <Link
          to="https://matelso.com/datenschutz/"
          label="Klicken Sie hier, um die Datenschutzrichtlinie des Datenverarbeiters zu lesen."
          isExternal
          target="_blank"
        />
      </p>
      <ul className={styles.marginBottomTwoRows}>
        <li>
          <span lang="en">Alphabet Inc.</span>, <span lang="en">Google LLC</span>,{' '}
          <span lang="en">Google Ireland Limited</span>
        </li>
      </ul>
    </Fragment>
  );
};
